import ItemCardImage from '@/components/GridItemCard/Card/components/ItemCardImage/ItemCardImage';
import ItemCardSaveIcon from '@/components/GridItemCard/Card/components/ItemCardSaveIcon/ItemCardSaveIcon';

import TimedBadgeContainer from '../TimedBadgeContainer/TimedBadgeContainer';

export type CardImageProps = {
    enterLinkHoverState: () => void;
    isCatalogDone: boolean;
    isMobile: boolean;
    itemId: number;
    leaveLinkHoverState: () => void;
};

const CardImage = ({ enterLinkHoverState, isCatalogDone, isMobile, itemId, leaveLinkHoverState }: CardImageProps) => {
    return (
        <section
            className="relative aspect-square"
            data-testid="timedPlusMyItemsCardImage"
            onMouseEnter={enterLinkHoverState}
            onMouseLeave={leaveLinkHoverState}
        >
            <TimedBadgeContainer itemId={itemId} />
            <span className="absolute top-xs right-xs z-[2] xsMax:top-2xs xsMax:right-[5px]">
                <ItemCardSaveIcon itemId={itemId} />
            </span>
            <div className="[grid-area:itemimage] xsMax:[&_img]:absolute xsMax:[&_img]:inset-0">
                <ItemCardImage
                    alignBannerBottomWithGap
                    itemId={itemId}
                    shouldGiveRangeForMobileSize={isMobile}
                    showBidStatus={!isCatalogDone}
                    useInFluidGrid
                />
            </div>
        </section>
    );
};

export default CardImage;
